import { createSlice } from '@reduxjs/toolkit';

import { fetchPublishedPosts } from './PublishedPostsThunks';
import { publishedSubCategories } from './../../pages/PublishedPosts/PublishedPosts';

export const initialState = {
    inProgress: [],
    notInProgress: [],
    category: null,
    loading: false,
    error: false,
};

const PublishedPostsSlice = createSlice({
    name: 'publishedPosts',
    initialState,
    reducers: {
        deletePublishedPost: (state, { payload }) => {
            state.inProgress = state.inProgress.filter(post => post.uid !== payload.id);
            state.notInProgress = state.notInProgress.filter(post => post.uid !== payload.id);
        },
        removeCompletedPost: (state, { payload }) => {
            state.inProgress = state.inProgress.filter(post => post.uid !== payload.id);
        },
        changeStatusOfPublishedPost: (state, { payload }) => {
            const index = state.inProgress.findIndex(post => post.uid === payload.id);
            state.inProgress[index].status = payload.status;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchPublishedPosts.pending, state => {
                state.error = false;
                state.loading = true;
            })
            .addCase(fetchPublishedPosts.fulfilled, (state, { payload }) => {
                state.inProgress = payload.inProgress;
                state.notInProgress = payload.notInProgress;
                state.loading = false;
            })
            .addCase(fetchPublishedPosts.rejected, (state, { payload }) => {
                state.error = true;
                state.loading = false;
                alert(payload);
            });
    },
});

export const PublishedPostsReducer = PublishedPostsSlice.reducer;
export const PublishedPostsActions = {
    ...PublishedPostsSlice.actions,
    fetchPublishedPosts,
};
